import {
  getPlanValidationRulesList,
  getPlanValidationRulesTemplate,
  getPlanValidationRuleById,
  createPlanValidationRule,
  createValidationRule,
  editPlanValidationRule,
  deletePlanValidationRule,
  getValidationRules,
  editValidationRule,
} from "@/http/setup/planValidationRules.js";

export default {
  namespaced: true,
  state: {
    validationRulesList: null,
    validationRuleTemplate: null,
    validationRuleById: null,
    validationRuleData: null,
  },
  actions: {
    async getPlanValidationRulesListAction({ commit }) {
      try {
        const resp = await getPlanValidationRulesList();
        commit("SET_VALIDATION_RULE_LIST", resp.data.pageItems);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getPlanValidationRulesTemplateAction({ commit }) {
      try {
        const resp = await getPlanValidationRulesTemplate();
        commit("SET_VALIDATION_RULE_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getPlanValidationRuleByIdAction({ commit }, data) {
      try {
        const resp = await getPlanValidationRuleById(data);
        commit("SET_VALIDATION_RULE_BY_ID", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getValidationRulesAction({ commit }, data) {
      try {
        const resp = await getValidationRules(data);
        commit("SET_VALIDATION_RULE_DATA", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editValidationRuleAction(_, data) {
      try {
        const resp = await editValidationRule(data.id, data.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createPlanValidationRuleAction(_, data) {
      try {
        const resp = await createPlanValidationRule(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createValidationRuleAction(_, data) {
      try {
        const resp = await createValidationRule(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deletePlanValidationRuleAction(_, data) {
      try {
        const resp = await deletePlanValidationRule(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editPlanValidationRuleAction(_, data) {
      try {
        const resp = await editPlanValidationRule(data.id, data.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_VALIDATION_RULE_LIST(state, payload) {
      state.validationRulesList = payload;
    },
    SET_VALIDATION_RULE_TEMPLATE(state, payload) {
      state.validationRuleTemplate = payload;
    },
    SET_VALIDATION_RULE_BY_ID(state, payload) {
      state.validationRuleById = payload;
    },
    SET_VALIDATION_RULE_DATA(state, payload) {
      state.validationRuleData = payload;
    },
  },
};
